<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="deleteContenidoNodo"
    >
      <header class="m-the-modal-header">
        <h5>
          {{ $modal.element.parent === null
            ? $t('mEditionMapPathModalDelete.title.path')
            : $t('mEditionMapPathModalDelete.title.step')
          }}
        </h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p>
          {{ $t('mEditionMapPathModalDelete.messageDelete.element') }}
          <b>{{ $modal.element.nodo.nombre }}</b>
          {{ $t('mEditionMapPathModalDelete.messageDelete.options') }}
        </p>
        <small class="text-color-danger">
            {{ $t('mFeedAssetsContentModalDelete.messageDelete.notReversed') }}
        </small>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionMapPathModalDelete.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapPathModalDelete',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionMapPathModalDelete.buttonPrimary'),
        behavior: 'delete',
        class: 'a-button-danger-primary',
        sending: false,
        type: 'submit'
      }
    }
  },

  methods: {
    deleteContenidoNodo () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.delete('contenido', 'deleteContenidoNodo', {}, [this.$modal.element.nodo.contenido, this.$modal.element.nodo.id])
          .then(response => {
            this.$modal.updateData('readElement')
            setTimeout(() => { this.$modal.updateData('readContenidoEntregables') }, 4000)
            this.$alerts.pushAlert('mEditionMapPathModalDelete', 'deleteContenidoNodo', this.$modal.element.parent === null
              ? 'successPath'
              : 'successStep'
            )
            this.$modal.closeModal()
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionMapPathModalDelete', 'deleteContenidoNodo', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
